module.exports = __webpack_public_path__ + "static/media/squarespace.965796e0.svg";